import { trackDashboardCtaClicked } from "analytics";
import { PATHS } from "constants/pathConstants";
import NextMoveCard from ".";
import Translate from "translate/Translate";
import { SHOW_ALL_NEXT_MOVE_CARDS } from "./showAllNextMoveCards";
import { useNextMoveMemberContext } from "./useNextMoveMemberContext";

const CologuardPersonalizedResourcesNextMoveCard = () => {
  const { hasCompletedCologuardPersonalizedResourcesSurvey } =
    useNextMoveMemberContext();

  const readyCard = (
      <NextMoveCard
        id="personalized-resources-ready-next-move"
        tag="new"
        title={<Translate text="Resources personalized to your interests" />}
        body={
          <Translate text="We've compiled trusted resources based on your interests. Have questions? Our navigation team is also available to discuss." />
        }
        subBody={
          <Translate text="See your resources or discuss with a navigator." />
        }
        link={{
          onClick: () => {
            trackDashboardCtaClicked({
              workflow: "learning_resources",
              ctaLocation: "next_move_card",
              ctaId: "personalized_resources"
            });
          },
          url: PATHS.HELP_CENTER_ROOT
        }}
      />
  );

  const surveyCard = (
    <NextMoveCard
      id="personalized-resources-next-move"
      tag="new"
      title={<Translate text="Get resources specific to your interests" />}
      body={
        <Translate text="There's a lot of health information out there. Some of it is helpful—and some is inaccurate or misleading. Let us know your interests and we'll share trusted resources to help you confidently improve your health." />
      }
      subBody={
        <Translate text="Take this 2-question survey to get connected with resources" />
      }
      link={{
        onClick: () => {
          trackDashboardCtaClicked({
            workflow: "learning_resources",
            ctaLocation: "next_move_card",
            ctaId: "learning_resources"
          });
        },
        url: PATHS.COLOGUARD_PERSONALIZED_RESOURCES_SURVEY
      }}
    />
  );

  if (SHOW_ALL_NEXT_MOVE_CARDS) {
    return (
      <>
        {surveyCard}
        {readyCard}
      </>
    );
  }

  return hasCompletedCologuardPersonalizedResourcesSurvey
    ? readyCard
    : surveyCard;
};

export default CologuardPersonalizedResourcesNextMoveCard;
